import React, {useEffect, useMemo, useState} from 'react'
import {Outlet} from 'react-router-dom'
import {StyledDashboard, StyledSwipableDrawer} from "./StyledDashboard";
import Drawer from "@mui/material/Drawer";
import {AppBar, IconButton, Toolbar, Tooltip} from "@mui/material";
import {DrawerContent} from "./DrawerContent";
import {useTheme} from "../../Providers/Theme";
import {useAuth} from "../../Providers/Auth";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars} from "@fortawesome/free-solid-svg-icons/faBars";
import {useLoggedinProfile} from "../../hooks/Api/useLoggedinProfile";
import {ProfileButton} from "./ProfileButton";
import {LazyLoadingSuspense} from "../LazyLoadingSuspense";
import useMediaQuery from "@mui/material/useMediaQuery";
import {faSun} from "@fortawesome/free-solid-svg-icons/faSun";
import {Locale} from "../../Providers/LocaleProvider";
import {faMoon} from "@fortawesome/free-solid-svg-icons/faMoon";
import {faAdjust} from "@fortawesome/free-solid-svg-icons/faAdjust";
import {SearchBox} from "./SearchBox";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";


export default (function () {

    const [open, setOpen] = useState(false)
    const [search, setSearch] = useState(false)
    const [collapsed, setCollapsed] = useState(false)
    const {setToken} = useAuth()
    const {data: profile} = useLoggedinProfile()


    const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)")
    const {toggleThemeMode, themeMode} = useTheme();

    const themeModeButton = useMemo(() => {
        switch (themeMode) {
            case 'light':
                return {
                    icon: <FontAwesomeIcon icon={faSun}/>,
                    label: <Locale>theme.light</Locale>
                }
            case 'dark':
                return {
                    icon: <FontAwesomeIcon icon={faMoon}/>,
                    label: <Locale>theme.dark</Locale>
                }
            default:
                return {
                    icon: <FontAwesomeIcon icon={faAdjust}/>,
                    label: <>
                        {prefersDarkMode ? <Locale>theme.dark</Locale> :
                            <Locale>theme.light</Locale>} (<Locale>theme.system</Locale>)
                    </>
                }
        }
    }, [themeMode, prefersDarkMode])

    useEffect(() => {
        if (search) {
            document.querySelector<HTMLInputElement>('.search-box input[name=q]')?.focus()
        }
    }, [search])

    return <>
        <StyledDashboard className={`${collapsed && 'collapsed'} ${search && 'search'}`}>
            <Drawer
                variant="permanent"
            >
                <DrawerContent
                    collapsed={collapsed}
                    toggleCollapsed={() => setCollapsed(!collapsed)}
                />
            </Drawer>
            <StyledSwipableDrawer
                keepMounted
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}>
                <DrawerContent
                    collapsed={collapsed}
                />
            </StyledSwipableDrawer>
            <main>
                <AppBar position="sticky" color="inherit" elevation={0}>
                    <Toolbar sx={{gap: "2px"}}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={() => setOpen(true)}
                            sx={{mr: 2, display: {md: 'none'}}}
                        >
                            <FontAwesomeIcon icon={faBars}/>
                        </IconButton>
                        {/*<Typography variant="h6" noWrap>*/}
                        {/*    <img className={"logo-image"} src={"logo.svg"}/>*/}
                        {/*</Typography>*/}
                        <IconButton
                            sx={{
                                display: {
                                    md: 'none',
                                },
                            }}
                            className="cancel-search" onClick={() => setSearch(false)} color={"inherit"} size={"small"}><FontAwesomeIcon
                            icon={faTimes}/></IconButton>
                        <SearchBox className="search-box" sx={{
                            display: {
                                xs: !search ? 'none' : 'grid', md: 'grid',
                            },
                            flex: {xs: 1, md: 'initial'},
                        }}/>
                        <div style={{flex: 1}}/>
                        <IconButton
                            sx={{
                                display: {
                                    md: 'none',
                                },
                            }}
                            className="show-search" onClick={() => setSearch(true)} color={"inherit"}
                            size={"small"}><FontAwesomeIcon
                            icon={faSearch}/></IconButton>
                        <ProfileButton
                            profile={profile}
                            logout={() => setToken(undefined)}
                        />
                        <Tooltip title={themeModeButton.label}>
                            <IconButton color={"inherit"} size={"small"}
                                        onClick={() => toggleThemeMode()}>{themeModeButton.icon}</IconButton>
                        </Tooltip>
                    </Toolbar>
                </AppBar>
                <React.Suspense fallback={<LazyLoadingSuspense/>}>
                    <Outlet/>
                </React.Suspense>
            </main>
        </StyledDashboard>
    </>
}) as React.FC
